export const CATEGORIES = [
  {
    id: 'chat',
    name: '雑談・自己紹介',
    subCategories: [
      { id: 'self-introduction', name: '自己紹介', categoryId: 'chat' },
      { id: 'general-talk', name: '雑談・お悩み相談', categoryId: 'chat' },
      { id: 'find-partner', name: '仲間募集', categoryId: 'chat' },
    ],
  },
  {
    id: 'report',
    name: '山登ったよ報告',
    subCategories: [
      { id: 'activity-report', name: '行動報告', categoryId: 'report' },
    ],
  },
  {
    id: 'mountain-info',
    name: '山情報（エリア別）',
    subCategories: [
      { id: 'kanto-okutama', name: '関東・奥秩父・那須・日光', categoryId: 'mountain-info' },
      { id: 'tanigawa-joshin', name: '谷川・上越・尾瀬・北信', categoryId: 'mountain-info' },
      { id: 'kita-chubu-yatsu', name: '北アルプス・中央アルプス・八ヶ岳', categoryId: 'mountain-info' },
      { id: 'minami-alps', name: '南アルプス', categoryId: 'mountain-info' },
      { id: 'tohoku-hokkaido', name: '東北・北海道', categoryId: 'mountain-info' },
      { id: 'kinki-west', name: '近畿・西日本', categoryId: 'mountain-info' },
      { id: 'shikoku', name: '四国', categoryId: 'mountain-info' },
      { id: 'kyushu', name: '九州', categoryId: 'mountain-info' },
      { id: 'overseas', name: '海外', categoryId: 'mountain-info' },
    ],
  },
  {
    id: 'deals',
    name: 'お得情報',
    subCategories: [
      { id: 'deals-info', name: 'お得情報', categoryId: 'deals' },
    ],
  },
  {
    id: 'gear',
    name: '登山道具談義',
    subCategories: [
      { id: 'rain-pack-shoes-light', name: 'レインウェア/ザック/登山靴/ヘッドライト', categoryId: 'gear' },
      { id: 'clothes-poles-helmet', name: '服装/防寒着/トレッキングポール/ヘルメット', categoryId: 'gear' },
      { id: 'tent', name: 'テント泊', categoryId: 'gear' },
      { id: 'watch-camera', name: '時計/スマートウォッチ/撮影機材', categoryId: 'gear' },
      { id: 'smartphone-carrier', name: 'スマホ/携帯キャリア', categoryId: 'gear' },
    ],
  },
  {
    id: 'mountain-food',
    name: '山めし',
    subCategories: [
      { id: 'snack-recipe', name: '行動食/おすすめレシピ', categoryId: 'mountain-food' },
      { id: 'cooking-tools-coffee', name: '山ごはんの道具/珈琲', categoryId: 'mountain-food' },
    ],
  },
  {
    id: 'safety',
    name: '遭難対策',
    subCategories: [
      { id: 'rescue-prevention', name: '遭難対策', categoryId: 'safety' },
    ],
  },
  {
    id: 'winter-gear',
    name: '雪山登山道具',
    subCategories: [
      { id: 'hardshell-crampons-axe', name: 'ハードシェル/アイゼン/ピッケル', categoryId: 'winter-gear' },
      { id: 'goggles-snowshoes-wakan', name: 'ゴーグル/スノーシュー/ワカン', categoryId: 'winter-gear' },
      { id: 'beacon-probe-shovel', name: 'ビーコン/プローブ/スコップ', categoryId: 'winter-gear' },
    ],
  },
];

export const HOME_CATEGORIES = [
  {
    id: 'consult-chat',
    title: 'お悩み相談・雑談',
    description: '登山の不安、初心者の質問、雑談まで。まずはここから気軽に話せます。',
    path: '/board/chat',
  },
  {
    id: 'mountain-report',
    title: '山登ったよ報告',
    description: '山情報はエリア別に整理。歩いた感想や注意点を探しやすくしています。',
    path: '/board/mountain-info',
  },
  {
    id: 'gear',
    title: '装備',
    description: '靴、レイヤリング、ザック、テントまで。装備の相談と感想をまとめています。',
    path: '/board/gear',
  },
];

export function getCategoryById(categoryId) {
  return CATEGORIES.find((c) => c.id === categoryId);
}

export function getSubCategoryById(categoryId, subCategoryId) {
  return getCategoryById(categoryId)?.subCategories.find((s) => s.id === subCategoryId);
}

export function getCategoryName(categoryId) {
  return getCategoryById(categoryId)?.name ?? categoryId;
}
